export default {"src":"/kelp/_next/static/media/eth.639b655c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};